module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_7_1.9cced798.png";